let lock = null;

export const requestWakeLock = async () => {
  try {
    if ('wakeLock' in navigator) {
      lock = await navigator.wakeLock.request('screen');
    }
  } catch (e) {
    console.warn('Wake Lock API failed or not supported:', e);
  }
};

export const releaseWakeLock = () => {
  lock?.release();
  lock = null;
};